"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useForm = (defaultState = {}, dependencies = []) => {
    const [formState, setFormState] = react_1.useState(defaultState);
    const handleFormChange = name => e => {
        var _a, _b;
        setFormState(Object.assign(Object.assign({}, formState), { [name]: (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : formState[name] }));
    };
    react_1.useEffect(() => {
        if (dependencies === null || dependencies === void 0 ? void 0 : dependencies.length)
            setFormState(defaultState);
    }, dependencies);
    const resetState = () => {
        setFormState(defaultState);
    };
    return [
        { defaultState, formState },
        { handleFormChange, setFormState, resetState }
    ];
};
exports.default = useForm;
